import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../context/Provider";
import { Menu } from "lucide-react";
import ProfileDropdown from "../sidebar/profileDropdown";

const Header = (props: any) => {
  const { authState, logOutNow } = useContext(GlobalContext);
  const roles = Array.isArray(authState?.roles) ? authState.roles : [];

  return (
    <div className="row border-bottom">
      <nav
        className="navbar navbar-static-top white-bg flex items-center justify-between px-4 py-2"
        role="navigation"
        style={{ marginBottom: "0" }}
      >
        <div className="navbar-header flex items-center">
          <Link
            className="navbar-minimalize minimalize-styl-2 btn btn-primary-button flex items-center justify-center"
            to="#"
            onClick={props.toggle}
            aria-label="Toggle navigation"
          >
            <Menu className="w-5 h-5" />
          </Link>
        </div>
        <div className="flex items-center gap-3 pr-2">
          <ProfileDropdown roles={roles} logOutNow={logOutNow} align="end" />
        </div>
      </nav>
    </div>
  );
};

export default Header;
